<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe-row" @click="msgAlerta=null">
        <span class="text">{{ msgAlerta }}</span>
    </div>


    <div class="form-edit-page">
        <div class="row row-space">
            <div class="form-item-char10">
                <label class="label-caption">Código</label>
                <div class="field-label field-label-end">{{ formatInteger(objEdicao.cdusuario) }}</div>
            </div>

            <div class="form-item">
                <label class="label-caption" for="nmusuario">Nome</label>
                <input type="text" v-model="objEdicao.nmusuario" id="nmusuario" required maxlength="80" v-uppercase />
            </div>

            <div v-if="globalStore.idusuario != objEdicao.id" class="form-item-char40">
                <UsuarioPerfilSelect
                    :ckEstabelecimento="props.perfilEstabelecimento"
                    :ckRt="props.perfilRt"
                    v-model:idSelecionado="objEdicao.idperfil"
                />
            </div>

            <div class="form-item-char15">
                <label class="label-caption" for="cpf">CPF</label>
                <input type="text" class="input-center" v-model="objEdicao.cpf" id="cpf" v-cpf maxlength="14" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="endereco">Endereço</label>
                <input type="text" v-model="objEdicao.endereco" id="endereco" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="nmendereco">Número</label>
                <input type="text" class="input-right" v-model="edNmEndereco" id="nmendereco" v-number maxlength="8" />
            </div>  
            <div class="form-item">
                <label class="label-caption" for="complemento">Complemento</label>
                <input type="text" v-model="objEdicao.complemento" id="complemento" maxlength="80" v-uppercase />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption" for="bairro">Bairro</label>
                <input type="text" v-model="objEdicao.bairro" id="bairro" maxlength="60" v-uppercase />
            </div>
            <div class="form-item">
                <label class="label-caption" for="nmmunicipio">Município</label>
                <input type="text" v-model="objEdicao.nmmunicipio" id="nmmunicipio" maxlength="80" v-uppercase />
            </div>
            <div class="form-item-char05">
                <label class="label-caption" for="uf">UF</label>
                <input type="text" class="input-center" v-model="objEdicao.uf" id="uf" maxlength="2" v-uppercase />
            </div>
            <div class="form-item-char10">
                <label class="label-caption" for="cep">CEP</label>
                <input type="text" class="input-center" v-model="objEdicao.cep" id="cep" v-cep maxlength="10" />
            </div>
        </div>
        
        <div class="row row-space">
            <div class="form-item-telefone">
                <label class="label-caption" for="celular">Celular</label>
                <input type="text" v-model="objEdicao.celular" id="celular" v-phone maxlength="15" />
            </div>
            <div class="form-item-telefone">
                <label class="label-caption" for="fone">Telefone</label>
                <input type="text" v-model="objEdicao.fone" id="fone" v-phone maxlength="15" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="email">Email Principal</label>
                <input type="email" v-model="objEdicao.email" id="email" />
            </div>
            <div class="form-item">
                <label class="label-caption" for="email2">Email Alternativo</label>
                <input type="email" v-model="objEdicao.email2" id="email2" />
            </div>
        </div>

        <div class="row row-space">
            <div class="form-item-char30">
                <label class="label-caption" for="registroorgao">Órgão de Registro</label>
                <input type="text" v-model="objEdicao.registro_orgao" id="registroorgao" />
            </div>

            <div class="form-item-char30">
                <label class="label-caption" for="registronumero">Nro Registro</label>
                <input type="text" class="input-right" v-model="edRegistroNumero" id="registronumero" v-number maxlength="10" />
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption" for="matriculanumero">Nro Matrícula</label>
                <input type="text" class="input-right" v-model="edMatriculaNumero" id="matriculanumero" v-number maxlength="10" />
            </div> 

            <div class="form-item">
                <label class="label-caption">Formação Acadêmica</label>
                <input type="text" v-model="objEdicao.formacao_academica" maxlength="100" v-uppercase />
            </div> 

            <div class="form-item">
                <label class="label-caption">Cargo/Função</label>
                <input type="text" v-model="objEdicao.nmcargo_funcao" maxlength="200" v-uppercase />
            </div> 
        </div>
        

        <div v-if="showSenha" class="row-start row-space">       
            <div class="form-item-char20">
                <label class="label-caption" for="login">Login Inicial</label>
                <input type="text" v-model="objEdicao.login" id="login" />
            </div>
            <div class="form-item-char20">
                <label class="label-caption" for="senha">Senha Inicial</label>
                <input type="text" v-model="objEdicao.senha" id="senha" />
            </div>
        </div>

        <div class="row-end row-space">
            <label for="ckAtivo">Ativo</label>
            <input type="checkbox" class="input-checkbox" id="ckAtivo" v-model="ckAtivo" />
        </div>

        <div class="row-end">
            <button type="button" v-if="!showSenha" @click="showModalSenha=true">Alterar Senha</button>
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="cancelForm">Cancelar</button>
        </div>
    </div>

    <div>
        <RedefinirLoginSenhaModal
            :visible="showModalSenha"
            @update:visible="(value) => (showModalSenha = value)"
            @submit="redefinirLoginSenha" />
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { criarUsuario } from '@/models/usuario';
import { formatInteger, integerFromString } from '@/funcoes/utils';
import { genericPut, getCadastroById, loginDisponivel } from '@/funcoes/api';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import RedefinirLoginSenhaModal from '@/components/RedefinirLoginSenhaModal.vue';
import UsuarioPerfilSelect from '@/components/selects/UsuarioPerfilSelect.vue';

const emit = defineEmits(['close', 'save']);
const props = defineProps({
    idEdicao: {type: Number, default: 0},
    idEstabelecimento: {type: Number, default: 0},
    cpf: {type: String, default: ''},
    perfilEstabelecimento: {type: Boolean, default: false},
    perfilGestor: {type: Boolean, default: false},
    perfilInspetor: {type: Boolean, default: false},
    perfilRt: {type: Boolean, default: false},
    perfilSupervisor: {type: Boolean, default: false}});
        
const ckAtivo = ref(false);
const edNmEndereco = ref(null);
const edRegistroNumero = ref(null);
const edMatriculaNumero = ref(null);
const isLoading = ref(null);
const msgAlerta = ref(null);
const objEdicao = ref(criarUsuario());
const showSenha = ref(false);
const showModalSenha = ref(false);

const cancelForm = async() => {emit('close');}

async function lerDados() {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (props.idEdicao > 0) {
            try{
                const req = await getCadastroById('usuario', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
                objEdicao.value.login=null;
                objEdicao.value.senha=null; // NECESSÁRIO PARA COMPATIBILIDADE COM OPÇÃO DE TROCAR SENHA... API BUSCA SENHA DO BANCO QUANDO FOR ATUALZIAR
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep                    = globalStore.idep;
            objEdicao.value.idestabelecimento       = props.idEstabelecimento;
            objEdicao.value.cpf                     = props.cpf;
            objEdicao.value.perfil_estabelecimento  = (props.perfilEstabelecimento)?'S':'N';
            objEdicao.value.perfil_gestor           = (props.perfilGestor)?'S':'N';
            objEdicao.value.perfil_inspetor         = (props.perfilInspetor)?'S':'N';
            objEdicao.value.perfil_rt               = (props.perfilRt)?'S':'N';
            objEdicao.value.perfil_supervisor       = (props.perfilSupervisor)?'S':'N';
        }
        objEdicao.value.idusuario                   = globalStore.idusuario;
        ckAtivo.value                               = objEdicao.value.ativo === 'S';     
        edNmEndereco.value                          = formatInteger(objEdicao.value.nmendereco);
        edRegistroNumero.value                      = formatInteger(objEdicao.value.registro_numero);
        edMatriculaNumero.value                     = formatInteger(objEdicao.value.matricula_numero);
        showSenha.value                             = objEdicao.value.id===0;
    } catch (error) {msgAlerta.value = error;
    }finally{isLoading.value=false;}
}

const redefinirLoginSenha = async({username, senha}) => {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const ok = await loginDisponivel(objEdicao.value.id, username);
        if (!ok) throw new Error('"Login" indisponível... necessário registrar outro');
        const r = await genericPut('/cad/usuario', {id: objEdicao.value.id, login: username, senha: senha});
        if (r.bolok == 1){msgAlerta.value="Nova senha alterada com sucesso"}else{msgAlerta.value=r.erro}
    } catch (error) {msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally {isLoading.value = false}
}

async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;

    try {
        if (props.perfilEstabelecimento && objEdicao.value.idestabelecimento==0) throw new Error('Informe o estabelecimento');
        isLoading.value = true;
        msgAlerta.value       = null
        if (objEdicao.value.id == 0){
            const ok = await loginDisponivel(0, objEdicao.value.login);
            if (!ok){
                msgAlerta.value = 'Este login já está em uso. Escolha outro.';
            }
        }
        if (!msgAlerta.value){
            objEdicao.value.ativo            = ckAtivo.value ? 'S' : 'N';
            objEdicao.value.nmendereco       = integerFromString(edNmEndereco.value);  
            objEdicao.value.registro_numero  = integerFromString(edRegistroNumero.value);  
            objEdicao.value.matricula_numero = integerFromString(edMatriculaNumero.value);  
            const response                   = await genericPut('/cad/usuario', objEdicao.value);
            if (response.bolok === 1){
                emit('save');
                emit('close');
            }else{
                msgAlerta.value = `ATENÇÃO: ${response.erro}`;
            }
        }
    } catch (error) {msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
}


function validarDados(){
    let x = '';
    let r = Validar.texto(objEdicao.value.nmusuario, '\n-Informe o nome do usuário');
    if (!r.ok) x += r.msg;
    r = Validar.cPF(objEdicao.value.cpf);
    if (!r.ok) x += `\n-${r.msg}`;

    if (showSenha.value){
        r = Validar.texto(objEdicao.value.login, '\n-Informe o login inicial para o usuário');
        if (!r.ok) x += r.msg;
        r = Validar.texto(objEdicao.value.senha, '\n-Informe a senha inicial para o usuário');
        if (!r.ok) x += r.msg;
    }
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}

onMounted(lerDados)
</script>